export default __webpack_public_path__ + "static/media/crownIco.b3ede3d5.svg";